var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#04D9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7531 6.20186C13.6476 6.09637 13.5045 6.03711 13.3553 6.03711C13.2062 6.03711 13.0631 6.09637 12.9576 6.20186L6.0633 13.0962C5.99263 13.1668 5.94207 13.255 5.91681 13.3517L5.16681 16.2231C5.11634 16.4163 5.17209 16.6218 5.3133 16.763C5.45451 16.9042 5.65999 16.9599 5.85321 16.9095L8.72453 16.1595C8.82122 16.1342 8.90945 16.0836 8.98012 16.013L15.8744 9.11868C16.0941 8.89901 16.0941 8.54285 15.8744 8.32318L13.7531 6.20186ZM6.96672 13.7837L13.3553 7.3951L14.6812 8.72093L8.29254 15.1096L6.49797 15.5783L6.96672 13.7837Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40039 18.0371C5.08973 18.0371 4.83789 18.289 4.83789 18.5996C4.83789 18.9103 5.08973 19.1621 5.40039 19.1621H16.6504C16.9611 19.1621 17.2129 18.9103 17.2129 18.5996C17.2129 18.289 16.9611 18.0371 16.6504 18.0371H5.40039Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.330ee4f9a48d3043446256ba3d299460.svg";
export { ForwardRef as ReactComponent };